<template>
  <div>
    <a-modal
      :title="isAdd ? '新建班级' : updateData.status == -1 ? '修改班级(待发布)' : updateData.status == 0? '修改班级(预开班)' : '修改班级(已开班)'"
      :maskClosable="false"
      :width="640"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :cancelText="'取消'"
      :okText="'确定'"
      @ok="handleSubmit"
      @cancel="handleCancel"
    >
      <a-spin v-show="updateLoading" size="small" class="spin"></a-spin>
      <a-form class="class-form" layout="horizontal" :form="form" v-show="!updateLoading" style="height: 66vh;">
        <a-form-item
          label="排课类型"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-select
            v-decorator="[
              'flexibleSchedule',
              { rules: [{ required: true, message: '请选择' }] },
            ]"
            @change="flexibleScheduleChange"
            placeholder="请选择"
            :disabled="updateData.status != -1 && updateData.status != 0 && !isAdd"
          >
            <a-select-option :value="0">固定排课</a-select-option>
            <a-select-option :value="1">灵活排课</a-select-option>
          </a-select>
        </a-form-item>
        <!-- 学期列表 -->
        <!-- !(!isAdd && updateData.status == 1) -->
        <a-form-item
          label="学期列表"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-select
            placeholder="请选择"
            @change="termChange"
            v-decorator="[
              'termId',
              { rules: [{ required: true, message: '请选择' }] },
            ]"
            :disabled="(!isAdd && updateData.status == 1)"
          >
            <a-select-option
              v-for="item in termList"
              :key="item.id"
              :value="item.id"
              >{{ item.termName }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <!-- 开班日期 -->
        <a-form-item
          label="开班日期"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-date-picker
            format="YYYY-MM-DD"
            class="modal-form-item"
            @change="startClassDate_change"
            :disabledDate="disabledDate_startClass"
            :disabled="!form.getFieldValue('termId') || (!isAdd && updateData.status == 1)"
            v-decorator="[
              'startClassDate',
              { rules: [{ required: true, message: '请选择' }] },
            ]"
          />
          <div v-if="showTip" style="white-space: nowrap">
            <a-icon type="warning" theme="twoTone" twoToneColor="#ffca02"/> 开班以后继续报名可能导致学生上课课节不完整
          </div>
        </a-form-item>

        <!-- 开始报名时间 -->
        <a-form-item
          label="开始报名时间"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-date-picker
            :showTime="
              !isAdd ? { defaultValue: moment('00:00:00', 'HH:mm:ss') } : { defaultValue: moment('00:00:00', 'HH:mm:ss') }
            "
            class="modal-form-item"
            format="YYYY-MM-DD HH:mm:ss"
            :disabledDate="disabledDate_applyStart"
            :disabled="!form.getFieldValue('startClassDate')"
            v-decorator="[
              'applyStartTime',
              { rules: [{ required: true, message: '请选择' }] },
            ]"
            @change="startDateChange"
          />
        </a-form-item>

        <!-- 开始报名时间 -->
        <a-form-item
          label="结束报名时间"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-date-picker
            :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }"
            class="modal-form-item"
            format="YYYY-MM-DD HH:mm:ss"
            :disabledDate="disabledDate_applyStart"
            :disabled="!form.getFieldValue('startClassDate')"
            v-decorator="[
              'applyEndTime',
              { rules: [{ required: true, message: '请选择' }] },
            ]"
            @change="startDateChange"
          />
        </a-form-item>

        <!-- 课程分类 -->
        <a-form-item
          label="课程分类"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-radio-group button-style="solid"  @change="classifyIdChange" 
            v-decorator="['classifyId',{ rules: [{ required: true, message: '请选择' }] },]">
            <a-radio-button :value="3" :disabled="!isAdd && classifyId != 3">
              托管班
            </a-radio-button>
            <a-radio-button :value="2" :disabled="!isAdd && classifyId != 2">
              社团课
            </a-radio-button>
            <a-radio-button :value="1" :disabled="!isAdd && classifyId != 1">
              特色课
            </a-radio-button>
          </a-radio-group>
          <div v-if="classifyId == 3" class="trusteeship">注：默认使用“作业辅导”课程来建班</div>
        </a-form-item>

        <!-- 结班日期 -->
        <a-form-item
          label="结班日期"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
          v-if="classifyId == 3"
        >
          
          <a-tooltip>
            <template slot="title">
              结班日期包含选中当天
            </template>
            <a-date-picker
              class="modal-form-item"
              format="YYYY-MM-DD"
              :disabledDate="disabledDate_endClass"
              :disabled="!form.getFieldValue('startClassDate') || (!isAdd && updateData.status == 1)"
              v-decorator="[
                'endClassDate',
                { rules: [{ required: true, message: '请选择' }] },
              ]"
            />
          </a-tooltip>
        </a-form-item>        

        <!-- 课程名称 -->
        <a-form-item
          label="课程名称"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
          v-show="classifyId != 3"
        >
          <a-select
            showSearch
            placeholder="请选择"
            :filterOption="false"
            @search="getCourseList"
            @change="courseChange"
            :notFoundContent="
              searchLoading_course ? undefined : '没有对应的课程'
            "
            v-decorator="[
              'courseId',
              { rules: [{ required: true, message: '请选择' }] },
            ]"
            :disabled="(!isAdd && updateData.status == 1)"
          >
            <a-spin
              v-if="searchLoading_course"
              slot="notFoundContent"
              size="small"
            />
            <a-select-option
              v-for="item in courseList"
              :key="item.id"
              :value="item.id"
              :title="`${item.courseName}${item.offeringType == 2?` — ${item.providerName}`:''}`"
              >
              {{ item.courseName }}{{item.offeringType == 2 ? ` — ${item.providerName}`: ''}}{{ item.classifyId == 2? '（'+ item.id + '）' : '' }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <!-- 建议教学时长范围 -->
        <a-form-item
          label="建议教学时长范围"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
          v-show="form.getFieldValue('courseId')"
        >
          <span>{{ courseTeachTime }}</span>
        </a-form-item>

        <!-- 适用年级 -->
        <a-form-item
          label="适用年级"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-select
            mode="multiple"
            placeholder="请选择"
            v-decorator="[
              'gradeScope',
              { rules: [{ required: true, message: '请选择' }] },
            ]"
          >
          <!-- filterGrade($store.getters.getGradeScope) -->
            <a-select-option
              v-for="(item, index) in schoolGrade"
              :key="index"
              :value="item.gradeTagId.toString()"
            >
              {{ item.gradeName }}
            </a-select-option>
            <!-- <a-select-option
              v-for="(item, index) in $store.getters.getGradeScope"
              v-if="gradeArr.includes(item.id)"
              :key="index"
              :value="item.id.toString()"
            >
              {{ item.tagName }}
            </a-select-option> -->
          </a-select>
          <div v-if="errGradeText && classifyId !=3" class="errGrade">{{ errGradeText }} 不在当前允许的年级范围内</div>
        </a-form-item>

        <!-- 上课计划 -->
        <a-form-item
          label="上课计划"
          :required="coursePlanRequired"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <div
            class="class-time-list"
            :class="{ 'no-border': teachingPlan.length == 0 }"
          >
            <div
              class="item"
              v-for="(item, index) in teachingPlan"
              :key="index"
            >
              <div class="value">
                {{ item.classWeeks | weekName }} {{ item.classTime }}
              </div>
              <div
                v-if="!(!isAdd && updateData.status == 1)"
                class="close hover-font-active"
                @click="deleteClassTime(item, index)"
              >
                <a-icon type="close" />
              </div>
            </div>
            <div v-if="!(!isAdd && updateData.status == 1)" class="oper hover-font-active" @click="addPlan()">添加</div>
            
            <div v-if="(!isAdd && updateData.status == 1) && teachingPlan.length == 0" >灵活排课无需上课计划</div>
          </div>

          <!-- <a-radio-group
            v-if="!isAdd && teachingPlan.length != 0"
            v-model="everyOtherWeek"
          >
            <a-radio :style="radioStyle" :value="0"> 每周 </a-radio>
            <a-radio :style="radioStyle" :value="1"> 隔周 </a-radio>
          </a-radio-group> -->
        </a-form-item>

        <a-form-item
          label="上课周期"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-select
            :value="0"
            v-model="everyOtherWeek"
            :disabled="!isAdd && updateData.status == 1"
          >
            <a-select-option :value="0"> 每周 </a-select-option>
            <a-select-option :value="1"> 隔周 </a-select-option>
          </a-select>
        </a-form-item>

        <!-- 上课时长 -->
        <a-form-item
          label="上课时长"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
          v-show="teachingPlan && teachingPlan.length > 0"
        >
          <span>{{
            classTime_interval ? classTime_interval + '分钟' : ''
          }}</span>
        </a-form-item>

        <!-- 班级名称 -->
        <a-form-item
          label="班级名称"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-input
            type="text"
            placeholder="请输入"
            v-decorator="[
              'className',
              {
                rules: [
                  {
                    required: true,
                    pattern: /^.{1,50}$/,
                    message: '请输入长度为1~50位的班级名称',
                  },
                ],
                validateTrigger: 'change',
              },
            ]"
          />
        </a-form-item>
        <!-- 是否允许跨校报名 -->
        <!-- 站点学期设置的跨校报名为是时，出现跨校报名选项 -->
        <a-form-item
          label="是否允许跨校报名"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
          v-show="showCrossSchool"
        >
          <a-radio-group
            name="radiogroup"
            @change="changeCrossSchool"
            v-decorator="[
              'isCrossSchool',
              {
                rules: [
                  {
                    required: true,
                    message: '请选择',
                  },
                ],
                validateTrigger: 'change',
                initialValue: '0',
              },
            ]"
          >
            <a-radio class="fisrt-radio" value="1">是</a-radio>
            <a-radio class="fisrt-radio" value="0">否</a-radio>
          </a-radio-group>
        </a-form-item>

        <!-- 教室名称 -->
        <a-form-item
          label="教室名称"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-select
            showSearch
            allowClear
            placeholder="请选择"
            :filterOption="false"
            @focus="searchClassroom"
            @change="classroomChange"
            :notFoundContent="
              searchLoading_classroom ? undefined : '没有查询结果'
            "
            v-decorator="['placeId']"
            :disabled="(!isAdd && updateData.status == 1)"
          >
            <!-- <a-spin
              v-if="searchLoading_classroom"
              slot="notFoundContent"
              size="small"
            /> -->
            <a-select-option
              v-for="item in classroomList"
              :key="item.id"
              :value="item.id"
              >{{ item.placeName }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <!-- 报名人数范围 -->
        <a-form-item
          label="报名人数范围"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <div class="munber-explain">
            <a-input-group compact>
              <a-input-number
                :min="lowerLimit"
                :max="upperLimit"
                class="person-scope"
                placeholder="请输入"
                v-decorator="[
                  'lowerLimit',
                  { rules: [{ required: true, message: '请输入' }] },
                ]"
              />
              <a-input class="person-gap" placeholder="~" disabled />
              <a-input-number
                :min="lowerLimit"
                :max="upperLimit"
                class="person-scope max-person"
                placeholder="请输入"
                v-decorator="[
                  'upperLimit',
                  { rules: [{ required: true, message: '请输入' }] },
                ]"
              />
            </a-input-group>
            <a-popover arrow-point-at-center placement="bottom" style="margin:0 40px 4px 0;">
                <template v-slot:content>
                  报名人数的范围取决于当前课程的允许报名范围以及所选教室的容纳人数。
                </template>
                <a-icon type="question-circle" class="icon-circle" />
            </a-popover>
          </div>
        </a-form-item>
        <!-- 班级标签 -->
        <a-form-item
          label="班级标签"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-select
            mode="multiple"
            placeholder="请选择"
            v-decorator="[
              'classFlagId',
              { rules: [{ required: true, message: '请选择' }] },
            ]"
          >
            <a-select-option
              v-for="item in classFlagIdList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.value }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <!-- 付费模式 -->
        <a-form-item
          label="付费模式"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-select
            showSearch
            placeholder="请选择"
            :filterOption="false"
            @change="paymentModeChange"
            v-decorator="[
              'paymentMode',
              { rules: [{ required: true, message: '请选择' }] },
            ]"
          >
            <!-- @search="getCourseList" -->
            <!-- :notFoundContent="searchLoading_course ? undefined : '没有对应的模式'" -->
            <!-- <a-spin v-if="searchLoading_course" slot="notFoundContent" size="small" /> -->
            <a-select-option
              v-for="(item, index) in paymentModeList"
              :key="index"
              :value="index"
              >{{ item }}</a-select-option
            >
          </a-select>
          <div class="tip">
            <div>预付费：报名时支付课程费用</div>
            <div>后付费：报名时家长无需支付费用即可报名成功</div>
            <div>
              注：后付费功能仅支持3.0APP版本及课后服务小程序，报名时家长订单金额为0，请谨慎使用。
            </div>
          </div>
        </a-form-item>

        <!-- 备注 -->
        <a-form-item
          label="备注"
          :labelCol="{ lg: { span: 7 } }"
          :wrapperCol="{ lg: { span: 13 } }"
        >
          <a-input
            type="text"
            placeholder="请输入"
            v-decorator="[
              'remark',
              {
                rules: [
                  {
                    required: false,
                    pattern: /^.{0,255}$/,
                    message: '最多输入255位',
                  },
                ],
                validateTrigger: 'change',
              },
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <class-time-modal
      @backTeachingPlan="backTeachingPlan"
      :teachingPlan="teachingPlan"
      ref="teachingPlan"
    ></class-time-modal>
    <a-modal
      :visible="crossSchollVisible"
      @ok="okCrossSchool"
      @cancel="cancelCrossSchool"
      :closable="false"
    >
      <p></p>
      <p>
        设置为允许跨校报名将会有其他学校符合要求的学员报名到此班级，是否确认？
      </p>
      <p></p>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'

import classSet from '../../api/classSet'

import institution from '../../api/institution'

import course from '../../api/course'

import education from '../../api/education'

import classroom from '../../api/classroom'

import term from '../../api/term'

import bureau from '../../api/bureau'

import { getDateDay } from '../../utils/date'

import moment from 'moment'

import ClassTimeModal from './ClassTimeModal'

export default {
  name: 'classFormModal',
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      isAdd: true,
      classId: '',
      schoolGrade:Vue.ls.get('schoolGrade'),
      updateData: {},
      searchLoading_course: false, //搜索课程方loading
      institutionList: [], //课程方list
      courseList: [], //课程列表
      courseListAll:[],
      courseFlag:0,
      dateFormat: 'YYYY-MM-DD HH:mm:ss',
      selectTimeList: [], //选课时间
      classroomList: [], //教室列表
      classroomInfo:{}, //教室信息
      searchLoading_classroom: false, //搜索班级loading
      termList: [], //学期列表
      nowTerm: [], //当前学期
      bureauSetting: {}, //教育局设置
      lowerLimit: 1,
      upperLimit: 1000,
      filterGrade_id: [],
      teachingPlan: [],
      classTime_interval: '', //上课计划时间间隔
      courseTeachTime: '', //建议教学时长
      nowCourse: {}, //当前选择课程
      paymentModeList: ['预付费', '后付费'], // 付费模式可选列表
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
        marginLeft: '200px',
      },
      everyOtherWeek: 0, //间隔时间
      crossSchollVisible: false,
      classFlagIdList: [
        { id: 3301, value: '全日制' },
        { id: 3302, value: '半日制' },
        { id: 3303, value: '寒假班' },
        { id: 3304, value: '暑假班' },
        { id: 3305, value: '周末班' },
      ],
      showCrossSchool: false,
      // flexibleSchedule: 0, //排课类型
      coursePlanRequired: true, //上课计划是否必填
      showTip: false,
      gradeArr:[], //年级
      errGrades:[], //失效的年级
      errGradeText:"", 
      classifyId:0, //课程类型
      updateLoading:false,
    }
  },
  components: {
    ClassTimeModal,
  },
  methods: {
    classifyIdChange(e){
      console.log(e.target.value)
      this.errGrades = []
      this.errGradeText = ''
      this.teachingPlan = []
      if(this.form.getFieldsValue().courseId) this.form.setFieldsValue({courseId: null})
      if(this.form.getFieldsValue().lowerLimit) this.form.setFieldsValue({lowerLimit: null})
      if(this.form.getFieldsValue().upperLimit) this.form.setFieldsValue({upperLimit: null})
      if(this.form.getFieldsValue().gradeScope) this.form.setFieldsValue({gradeScope: []})
      this.classifyId = e.target.value
      this.getCourseList()
    },
    flexibleScheduleChange(e) {
      if (e == 1) {
        this.coursePlanRequired = false
      } else {
        this.coursePlanRequired = true
      }
    },
    okCrossSchool() {
      this.crossSchollVisible = false
    },
    //允许跨校报名需要弹框二次确认，关闭弹框
    cancelCrossSchool() {
      this.crossSchollVisible = false
      this.form.setFieldsValue({ isCrossSchool: '0' })
    },
    //是否允许跨校报名
    changeCrossSchool(e) {
      if (e.target.value == 1) {
        this.crossSchollVisible = true
      }
    },
    moment,
    //添加上课计划
    addPlan() {
      let courseId = this.form.getFieldValue('courseId')
      this.nowCourse = this.getCourse(courseId)
      if (!courseId) {
        this.$message.warn('请先选择课程')
      } else {
        this.$refs.teachingPlan.init(this.nowCourse, this.classTime_interval)
      }
    },

    //返回上课计划
    backTeachingPlan(value) {
      this.teachingPlan.push(value.teachingPlan)
      this.classTime_interval = value.interval
    },

    deleteClassTime(item, index) {
      this.teachingPlan.splice(index, 1)
      if (this.teachingPlan.length == 0) {
        this.classTime_interval = ''
      }
    },

    filterGrade(gradeList) {
      if (this.filterGrade_id.length == 0) return gradeList
      let tempList = []
      this.filterGrade_id.map((id) => {
        const tempItem = this.getItem(gradeList, id, 'id')
        if (tempItem) {
          tempList.push(this.getItem(gradeList, id, 'id'))
        }
      })
      return tempList
    },

    getItem(list, id, key) {
      let tempItem = null
      list.map((item) => {
        if (item[key] == id) {
          tempItem = item
        }
      })
      return tempItem
    },

    //课程修改
    courseChange(id) {
      //清空课程计划
      this.teachingPlan = []
      this.nowCourse = this.getCourse(id)
      this.errGrades = []
      //设置form表单
      let formData = {}
      //最低最高人数
      formData.lowerLimit = this.nowCourse.lowerLimit || null
      formData.upperLimit = this.nowCourse.upperLimit || null
      //使用年级
      let tempGrade = []
      formData.gradeScope = []
      tempGrade = this.nowCourse.gradeScope
        ? this.nowCourse.gradeScope.split(',')
        : []
      if(tempGrade.length>0){
        tempGrade.forEach(item =>{
          if (this.gradeArr.includes(parseInt(item))){
            formData.gradeScope.push(item)
          }else {
            this.errGrades.push(parseInt(item))
          }
        })
      }
      if(this.errGrades){
        this.handeleErrGrade()
      }
      this.form.setFieldsValue(formData)

      //设置限制
      this.setLimit_course(id)

      this.setCourseTeachTime(id)
    },

    //根据课程设置限制
    setLimit_course(id) {
      if (!id) return
      this.nowCourse = this.getCourse(id)
      if (!this.nowCourse) return
      //设置最低最高人数
      if(this.classroomInfo && this.classroomInfo.capacity <this.nowCourse.lowerLimit){
        this.classroomFull()
      }
      this.lowerLimit = this.nowCourse.lowerLimit || 1
      this.upperLimit = this.classroomInfo.capacity? Math.min(this.nowCourse.upperLimit,this.classroomInfo.capacity) :this.nowCourse.upperLimit
      
      //年级
      this.filterGrade_id = this.nowCourse.gradeScope
        ? this.nowCourse.gradeScope.split(',')
        : []
    },

    //根据ID获取课程
    getCourse(id) {
      let tempCourse = null
      this.courseList.map((item) => {
        if (item.id == id) {
          tempCourse = item
        }
      })
      return tempCourse
    },

    //开班_禁用日期
    disabledDate_startClass(current) {
      // console.log('current',current)
      return (
        current &&
        (current < moment(this.nowTerm.startDate) ||
          current < moment() ||
          current > moment(this.nowTerm.endDate))
      )
    },

    //结班_禁用日期
    disabledDate_endClass(current) {
      // console.log('current',this.nowTerm.endDate)
      let startClassDate = this.form.getFieldValue('startClassDate')
      return (
        current && (current <= moment(moment(startClassDate).format('YYYY-MM-DD') +' 24:00:00')||
          current >= moment(moment(this.nowTerm.endDate).format('YYYY-MM-DD') +' 24:00:00'))
      )
    },

    //开始报名时间_禁用日期
    disabledDate_applyStart(current) {
      if (
        this.isAdd ||
        this.updateData.status == 0 ||
        this.updateData.status == 1
      ) {
        return false
      }
      //开班时间
      let startClassDate = this.form.getFieldValue('startClassDate')
      //自动开班时间
      let openClassDays = this.bureauSetting.openClassDays || 0
      return (
        current &&
        (current >=
          moment(
            moment(startClassDate)
              .add(-openClassDays, 'days')
              .format('YYYY-MM-DD') + ' 24:00:00'
          ) ||
          current < moment(moment().format('YYYY-MM-DD') + ' 00:00:00'))
      )
    },

    //学期改变
    termChange(key) {
      //找到对应学期
      this.termList.map((item) => {
        if (item.id == key) {
          this.nowTerm = item
        }
      })
      console.log('this.nowTerm.crossSchool', this.nowTerm)
      if (this.nowTerm.crossSchool == 1) {
        this.showCrossSchool = true
        console.log('this.updateData', this.updateData)
        // console.log('key', key)
        if (this.updateData.termId == key) {
          console.log('----', this.updateData.isCrossSchool)
          this.form.setFieldsValue({
            isCrossSchool: this.updateData.isCrossSchool.toString(),
          })
        } else {
          this.form.setFieldsValue({ isCrossSchool: '0' })
          // console.log('222')
        }
      } else {
        this.showCrossSchool = false
      }
    },

    //修改开班日期，清空开始报名时间和结束报名时间
    startClassDate_change(e) {
      this.form.setFieldsValue({
        applyStartTime: null,
        applyEndTime: null,
        endClassDate: null
      })
    },
    //修改开始报名时间 用于判断
    startDateChange(e, q) {
      this.$nextTick(() => {
        let startClassDate = this.form.getFieldValue('startClassDate')
        let applyStartTime = this.form.getFieldValue('applyStartTime')
        let applyEndTime = this.form.getFieldValue('applyEndTime')
        if ((this.isAdd || this.updateData.status == 0) && startClassDate) {
          let res =
            moment(moment(applyStartTime).format('YYYY-MM-DD hh:mm:ss')) >
              moment(
                moment(startClassDate).format('YYYY-MM-DD') + ' 00:00:00'
              ) ||
            moment(moment(applyEndTime).format('YYYY-MM-DD hh:mm:ss')) >
              moment(moment(startClassDate).format('YYYY-MM-DD') + ' 00:00:00')
          this.showTip = res
        } else {
          this.showTip = false
        }
      })
    },

    //搜索课程方
    searchInstitution(val = '') {
      this.searchLoading_course = true
      institution.searchInstitution({ institutionName: val }).then((res) => {
        this.searchLoading_course = false
        this.institutionList = res.data
      })
    },

    //获取选课时间的List
    setClassTime_interval(valueList) {
      console.log('valueList', valueList)
      //为空直接返回
      if (valueList && valueList.length == 0) return
      const teachingPlanList = valueList[0].classTime.split('-')
      const startTime = teachingPlanList[0]
      const endTime = teachingPlanList[1]
      education.getClassTimeList().then((res) => {
        res.data.map((item) => {
          if (startTime == item.startTime && endTime == item.endTime) {
            this.classTime_interval = item.interval
          }
        })
      })
    },

    //设置上课时间
    setCourseTeachTime(id) {
      if(!this.courseList.some(item=>item.id==id)) {
        this.courseTeachTime = '课程未加入选课'
        return
      }
      this.courseList.map((item) => {
        if (item.id == id) {
          console.log('item', item)
          this.courseTeachTime = item.teachingTime + '分钟'
        }
      })
    },

    //初始化，显示
    init(type, params) {
      // console.log('type', type)
      console.log('params', params)
      this.visible = true
      this.isAdd = type === 'update' ? false : true
      this.filterGrade_id = []
      this.teachingPlan = []
      this.classTime_interval = ''
      this.courseTeachTime = ''
      this.errGrades = []
      //初始化form表单数据
      if (params) {
        this.updateLoading = true
        this.updateData = params
        let formData = {}
        let tempGrade = []
        this.classifyId = params.classifyId
        formData.classifyId = params.classifyId
        formData.termId = params.termId
        formData.className = params.className
        tempGrade = params.gradeScope.split(',')
        // console.log('errGrades', this.errGrades)
        formData.courseId = params.courseId
        formData.lowerLimit = params.lowerLimit
        formData.upperLimit = params.upperLimit
        formData.placeId = params.placeId
        formData.isCrossSchool = params.isCrossSchool.toString()
        formData.flexibleSchedule = params.flexibleSchedule || 0
        formData.remark = params.remark
        // 处理年级数据
        // console.log('params.classifyId', params.classifyId,this.courseListAll)
        if(params.classifyId != 3){
          this.courseList = this.courseListAll.filter(item=> item.classifyId == params.classifyId)
          // 显示错误年级
          formData.gradeScope = []
          tempGrade.forEach(item =>{
            if (this.gradeArr.includes(parseInt(item))){
              formData.gradeScope.push(item)
            }else {
              this.errGrades.push(parseInt(item))
            }
          })
          if(this.errGrades) this.handeleErrGrade()
        } else {
          formData.gradeScope = params.gradeScope? params.gradeScope.split(','): []
        }
        

        if (params.classFlagId) {
          let classFlag = [
            { id: 3301, value: '全日制' },
            { id: 3302, value: '半日制' },
            { id: 3303, value: '寒假班' },
            { id: 3304, value: '暑假班' },
            { id: 3305, value: '周末班' },
          ]
          formData.classFlagId = params.classFlagId.split(',').map((item) => {
            let b
            classFlag.forEach((i) => {
              if (i.value == item) {
                b = i.id
              }
            })
            return b
          })
        }
        // console.log('formData.classFlagId', formData.classFlagId)
        formData.applyStartTime = moment(params.applyStartTime).format(
          'YYYY-MM-DD HH:mm:ss'
        )
        formData.applyEndTime = moment(params.applyEndTime).format(
          'YYYY-MM-DD HH:mm:ss'
        )
        formData.startClassDate = moment(params.startClassDate)
        formData.endClassDate = moment(params.endClassDate)
        this.teachingPlan = params.teachingPlan
          ? JSON.parse(params.teachingPlan)
          : []
        formData.paymentMode = params.paymentMode
        this.everyOtherWeek = params.everyOtherWeek || 0
        if (params.flexibleSchedule == 1) {
          this.coursePlanRequired = false
        }

        //学期回显
        this.termChange(formData.termId)

        //设置课程限制
        this.setLimit_course(formData.courseId)

        //设置建议教学时长
        this.setClassTime_interval(this.teachingPlan)

        //设置上课时间
        this.setCourseTeachTime(formData.courseId)

        //记录当前班级的ID
        this.classId = params.id

        setTimeout(() => {
          this.setFormValue(formData)
          this.startDateChange()
          this.updateLoading = false
        }, 100)
      } else {
        setTimeout(() => {
          this.form.resetFields()
          this.form.setFieldsValue({ flexibleSchedule: 0 })
          this.startDateChange()
          this.courseList = []
        }, 1)
      }
    },
    setFormValue(formData) {
      this.form.setFieldsValue({
        flexibleSchedule:formData.flexibleSchedule,
        termId:formData.termId,
        startClassDate:formData.startClassDate,
        applyStartTime:formData.applyStartTime,
        applyEndTime:formData.applyEndTime,
        classifyId:formData.classifyId,
        courseId:formData.courseId,
        gradeScope:formData.gradeScope,
        className:formData.className,
        isCrossSchool:formData.isCrossSchool,
        placeId:formData.placeId,
        lowerLimit:formData.lowerLimit,
        upperLimit:formData.upperLimit,
        classFlagId:formData.classFlagId,
        remark:formData.remark,
        paymentMode:formData.paymentMode
      })
      if(formData.classifyId == 3) {
        this.form.setFieldsValue({
          endClassDate:formData.endClassDate
        })
      }
      // 解决课程移除选课后的回显问题
      if (!this.courseList.some(item=>item.id == formData.courseId)){
        this.form.setFieldsValue({
          courseId:formData.className
        })
      }
    },
    handeleErrGrade(){
      // console.log(this.errGrades,'this.errGrades',this.$store.getters.getGradeScope)
      let temp = []
      this.$store.getters.getGradeScope.forEach(item =>{
        if(this.errGrades.includes(item.id)){
          temp.push(item.tagName)
        }
      })
      this.errGradeText = temp.join(',')
      // console.log(this.errGradeText,'temp___________')
    },
    //隐藏
    handleCancel() {
      this.visible = false
      this.errGrades = []
      this.errGradeText = ''
      this.classifyId = 0
      this.courseList = this.courseListAll
      // this.$emit('closeForm')
      this.formData = {}
      this.classroomInfo = {}
      this.nowCourse = {}
      this.everyOtherWeek = 0
      // this.flexibleSchedule = 0
      this.showCrossSchool = false
      this.coursePlanRequired = true
      this.form.setFieldsValue({ classFlagId: [] })
    },

    //提交表单
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, value) => {
        console.log('输入的内容是：', value)
        //处理年级范围
        if (value.gradeScope && value.gradeScope.length > 0) {
          value.gradeScope = value.gradeScope.join()
        }

        if (value.applyStartTime) {
          value.applyStartTime = moment(value.applyStartTime).format(
            this.dateFormat
          )
        }

        if (value.applyEndTime) {
          value.applyEndTime = moment(value.applyEndTime).format(
            this.dateFormat
          )
        }

        if (value.startClassDate) {
          value.startClassDate = value.startClassDate.format('YYYY-MM-DD')
        }

        if (value.endClassDate) {
          value.endClassDate = value.endClassDate.format('YYYY-MM-DD')
        }

        if (this.teachingPlan && this.teachingPlan.length > 0) {
          value.teachingPlan = JSON.stringify(this.teachingPlan)
        }

        if (typeof value.flexibleSchedule != 'undefined') {
          if (value.flexibleSchedule == 0 && this.teachingPlan.length == 0) {
            this.$message.warn('请添加上课计划')
            return
          } else {
            //上课计划重复校验
            let tempSet = new Set()
            this.teachingPlan.map((item) => {
              tempSet.add(JSON.stringify(item))
            })
            if (tempSet.size != this.teachingPlan.length) {
              this.$message.warn('上课计划重复，请修改')
              return
            }
          }
        }
        //校验通过
        if (!err) {
          value.institutionId = this.findCourse_providerId(value.courseId)
          //开始报名时间不能比结束报名时间晚
          if (moment(value.applyStartTime) > moment(value.applyEndTime)) {
            this.$message.error('结束报名时间不能比开始报名时间早')
          } else {
            //获取课程信息
            let courseItem = this.getCourseValue(value.courseId)
            value.offeringType = courseItem.offeringType
            value.providerId = courseItem.providerId
            if (this.isAdd) {
              this.addClass({
                ...value,
                everyOtherWeek: this.everyOtherWeek,
                flexibleSchedule: value.flexibleSchedule,
              })
            } else {
              this.updateClass({
                ...value,
                everyOtherWeek: this.everyOtherWeek,
                flexibleSchedule: value.flexibleSchedule,
              })
            }
          }
        }
      })
    },

    getCourseValue(courseId) {
      let courseItem = {}
      //找到课程
      this.courseList.map((item) => {
        if (item.id == courseId) {
          courseItem = item
        }
      })
      return courseItem
    },

    findCourse_providerId(courseId) {
      let res = ''
      let courseItem = {}
      //找到课程
      this.courseList.map((item) => {
        if (item.id == courseId) {
          courseItem = item
        }
      })
      //课程方
      if (courseItem.offeringType == '2') {
        res = courseItem.providerId
      }
      return res
    },

    //新增班级
    addClass(value) {
      classSet.addClass(value).then((res) => {
        this.$message.success('新增成功')
        this.handleCancel()
        this.$emit('addClass', res.data)
      })
    },

    //修改班级
    updateClass(value) {
      console.log('value', value)
      if (this.updateData.status == 1) {
        value = {
          applyStartTime: value.applyStartTime,
          applyEndTime: value.applyEndTime,
          className: value.className,
          lowerLimit: value.lowerLimit,
          upperLimit: value.upperLimit,
          gradeScope: value.gradeScope,
          paymentMode: value.paymentMode,
          classFlagId: value.classFlagId,
          isCrossSchool: value.isCrossSchool,
          remark: value.remark,
        }
      }
      // console.log('value', value)
      // console.log('this.classId', this.classId)
      // console.log('this.updateData', this.updateData)

      classSet.updateClass(this.classId, value).then((res) => {
        this.$message.success('修改成功')
        this.handleCancel()
        this.$set(this.updateData, 'placeId', res.data.placeId)
        this.$set(this.updateData, 'placeName', res.data.placeName)
        Object.assign(this.updateData, res.data)
        this.$emit('addClass')
      })
    },

    //查询课程列表
    getCourseList(name,flag) {
      let params = {}
      // params.status = '1'
      params.classifyId = this.classifyId ? this.classifyId : 0
      if (name) {
        params.courseName = name
      }
      course.listClassCourse(params).then((res) => {
        this.courseList = res.data.list
        if (this.courseFlag == 0) this.courseListAll = res.data.list
        this.courseFlag++
        if(flag) return
        if(this.classifyId == 3) {
          // console.log(this.courseList[0].id)
          this.form.setFieldsValue({ courseId: this.courseList[0].id })
          this.courseChange(this.courseList[0].id)
        }
      })
    },

    //教室列表
    searchClassroom(key = '') {
      if (!this.$store.getters.schoolId || this.updateData.status == 1) return
      this.searchLoading_classroom = true
      if (this.isAdd) {
        classroom
          .addListPlace({ schoolId: this.$store.getters.schoolId })
          .then((res) => {
            this.searchLoading_classroom = false
            this.classroomList = res.data
          })
          .catch((err) => {
            this.classroomList = []
          })
      } else {
        classroom
          .listPlace(this.updateData.id)
          .then((res) => {
            this.searchLoading_classroom = false
            this.classroomList = res.data
          })
          .catch((err) => {
            this.classroomList = []
          })
      }
    },
    classroomChange(e){
      this.classroomInfo = this.classroomList.find(item=> item.id == e)
      if(this.classroomInfo && this.classroomInfo.capacity){
        if(this.nowCourse && this.nowCourse.lowerLimit > this.classroomInfo.capacity){
          this.classroomFull()
          return
        }
        this.upperLimit = Math.min(this.nowCourse.upperLimit,this.classroomInfo.capacity)
      } else {
        this.upperLimit = this.nowCourse.upperLimit
      }
    },
    classroomFull(){
      this.$message.warn(`当前教室的最大人数为${this.classroomInfo.capacity}人，当前课程最小报名人数为${this.nowCourse.lowerLimit}人，请重新选择教室`)
        this.classroomInfo = {}
        this.$nextTick(()=>{
          this.form.setFieldsValue({ placeId: '' })
        })
    },
    //获取学期列表
    getTermList_all() {
      term.getTermList_all().then((res) => {
        this.termList = res.data
      })
    },

    //获取教育局设置
    getBureauSetting() {
      bureau.getBureauSetting().then((res) => {
        this.bureauSetting = res.data
      })
    },

    refreshSchool() {
      this.getCourseList()
      this.getTermList_all()
    },

    // 切换付费模式
    paymentModeChange(e) {
      // console.log(e);
    },
  },
  created() {
    this.gradeArr = Vue.ls.get('schoolGrade').map(item=>{
      return item.gradeTagId
    })
    this.searchInstitution()
    //初始化上课周期list
    this.refreshSchool()
    this.getTermList_all()
    this.getBureauSetting()
    this.searchClassroom()
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.class-form {
  height: calc(100vh - 260px);
  overflow-y: auto;
  overflow-x: hidden;
}

.person-scope {
  width: 100px;
  text-align: center;
  display: inline-block;
}
.max-person {
  border-left: none;
}
.person-gap {
  width: 30px;
  border-left: 0;
  pointer-events: none;
  background: #fff;
}
.modal-form-item {
  width: 100% !important;
}
.class-time-list {
  display: inline-block;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 6px 10px;
  > .item {
    border-radius: 4px;
    line-height: 36px;
    height: 36px;
    padding: 0px 10px;
    margin: 6px 0px;
    background: #cfcfcf;
    > .value {
      display: inline-block;
      vertical-align: middle;
      width: 226px;
    }
    > .close {
      font-size: 16px;
      display: inline-block;
      margin-left: 10px;
      vertical-align: middle;
    }
  }
  > .oper {
    color: $primary-color;
    padding-left: 4px;
  }
}
.no-border {
  border: none !important;
  padding: 0px !important;
}
.tip {
  width: 100%;
  line-height: 20px;
  font-size: 14px;
  div {
    margin-top: 8px;
  }
}
.errGrade {
  margin-top: 2px;
  width: 30vw;
  height: 16px;
  font-size: 12px;
  color: silver;
  line-height: 14px;
}
.trusteeship {
  height: 22px; 
  line-height: 22px;
  margin-bottom:-22px;
}
.spin {
  height: 66vh;
}
.munber-explain {
  display: flex;
  height: 40px;
  align-items: center;
}
</style>
